import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { Industries } from './components/Industries';
import { Trust } from './components/Trust';
import { CloudSurgard } from './components/CloudSurgard';
import { Pricing } from './components/Pricing';
import { CTABanner } from './components/CTABanner';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white text-zinc-900 selection:bg-peoplecall selection:text-white" data-id="element-0">
      <Nav data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problem data-id="element-4" />
        <HowItWorks data-id="element-5" />
        <Features data-id="element-6" />
        <Industries data-id="element-7" />
        <Trust data-id="element-8" />
        <CloudSurgard data-id="element-9" />
        <Pricing data-id="element-10" />
        <CTABanner data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}